import moment from 'moment';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { ProjectId, User } from 'api/models';
import { Select } from 'components/atoms/select';
import { VirtualizedMenuList } from 'components/atoms/select/custom-components';
import { AvatarOption } from 'components/molecules/squad-picker/picker';
import { useProjectSquad } from 'components/molecules/squad-picker/use-squad-options';
import { useCurrentUserProjectAccess } from 'hooks/permissions';
import { getFormattedUsersList, getOptions } from './utils';

interface Props {
  options: User[];
  projectId: ProjectId;
  onChange: (value: User[]) => void;
  selectedUsers: User[];
  placeholder?: string;
  isDisabled?: boolean;
  isLoading?: boolean;
}

export const SelectUserDropdown: FC<Props> = ({
  isDisabled,
  isLoading,
  options,
  projectId,
  placeholder,
  onChange,
  selectedUsers,
}) => {
  const { isProjectAdmin } = useCurrentUserProjectAccess(projectId);
  const { data: projectSquad } = useProjectSquad(projectId);
  const nonMembersIds = projectSquad.notInProject.map((user) => user.userId);

  return (
    <Select
      isMulti
      type="user"
      options={getOptions(options, nonMembersIds)}
      value={getFormattedUsersList(selectedUsers, nonMembersIds)}
      isDisabled={isDisabled || isLoading}
      isLoading={isLoading}
      onChange={onChange}
      placeholder={placeholder}
      noOptionsMessage={() => {
        if (isProjectAdmin) {
          return (
            <FormattedMessage
              id="project.invitation.native.admin.help"
              values={{
                a: (chunks) => (
                  <Link to="/settings/team-members">{chunks}</Link>
                ),
              }}
            />
          );
        }

        return (
          <FormattedMessage id="project.invitation.native.collaborator.help" />
        );
      }}
      components={{
        DropdownIndicator: () => null,
        IndicatorSeparator: () => null,
        Option: AvatarOption,
        MenuList: VirtualizedMenuList,
      }}
      startDate={moment().startOf('day')}
      dueDate={moment().endOf('day')}
    />
  );
};
